import { render } from "./ContentDoubts.vue?vue&type=template&id=261af340&scoped=true&ts=true"
import script from "./ContentDoubts.vue?vue&type=script&lang=ts"
export * from "./ContentDoubts.vue?vue&type=script&lang=ts"

import "./ContentDoubts.vue?vue&type=style&index=0&id=261af340&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261af340"]])

export default __exports__